import React from 'react';
import Select from 'react-select';
import dsSelectStyles from './reactSelectDsStyles';

// Reusable searchable single-select for picking a long-text option (e.g. a source survey
// QUESTION or a source ANSWER OPTION). Options show TRUNCATED text (the values can be very
// long); the full text of the selection is shown below in a read-only textarea. An empty
// option allows clearing the value (NULL). Search matches the FULL (untruncated) text.
//
// Generic + presentational: it does not fetch anything. The caller supplies `selectValues`
// as an array of { value, text, secondaryId? } (secondaryId is an optional id shown in the
// option label, e.g. a third-party id). This makes it reusable for questions and answer
// options alike — only the option list differs.
const MAX_OPTION_LENGTH = 90;

const truncate = (text) =>
  text && text.length > MAX_OPTION_LENGTH ? text.slice(0, MAX_OPTION_LENGTH) + '…' : text || '';

export default class SourceQuestionSelect extends React.Component {
  static defaultProps = {
    value: '',
    selectValues: [],
    fieldName: 'defaultFieldname',
    onChange: () => {},
    placeholder: 'Search and select...',
    emptyOptionLabel: '(Ignored)',
    numberOfRows: 4, // height of the read-only full-text textarea below the dropdown
  };

  buildOptions() {
    const empty = { value: '', label: this.props.emptyOptionLabel, fullText: '' };
    const mapped = (this.props.selectValues || []).map((o) => ({
      value: o.value,
      label: `${truncate(o.text)}${o.secondaryId !== null && o.secondaryId !== undefined ? ` (${o.secondaryId})` : ''}`,
      fullText: o.text || '',
    }));
    return [empty, ...mapped];
  }

  // Match against the full text even though the option label is truncated.
  filterOption(candidate, input) {
    if (!input) return true;
    const haystack = `${candidate.data.fullText || ''} ${candidate.label || ''}`.toLowerCase();
    return haystack.includes(input.toLowerCase());
  }

  render() {
    const options = this.buildOptions();
    const normalizedValue = this.props.value === null || this.props.value === undefined ? '' : this.props.value;
    const selectedOption = options.find((o) => o.value === normalizedValue) || options[0];

    return (
      <div className='w-100'>
        <Select
          options={options}
          value={selectedOption}
          onChange={(option) => this.props.onChange(this.props.fieldName, option ? option.value : '')}
          filterOption={this.filterOption}
          placeholder={this.props.placeholder}
          isClearable={false}
          // Portal the menu so it isn't clipped by the panel's scroll container.
          menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
          // Fixed, as in MultiChoice: an 'absolute' portalled menu can loop with the page scroll (CD-5713).
          menuPosition='fixed'
          styles={dsSelectStyles}
        />
        <textarea
          className='w-100 form-control form-control-sm mt-1'
          rows={this.props.numberOfRows}
          readOnly={true}
          value={selectedOption ? selectedOption.fullText : ''}
        />
      </div>
    );
  }
}
